<template>
<div class="chapter">
<div class="inner_page">
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p1"><span class="sz"><i>Old now is earth, and none may count her days.</i></span></p>
<p class="p1"><span class="sz"><i>Earth might be fair, and all men glad and wise.</i></span></p>
<p class="p1"><span class="sz"><i>Age after age, their tragic empires rise,</i></span></p>
<p class="p1"><span class="sz"><i>Built while they dream, and in that dreaming weep:</i></span></p>
<p class="p1"><span class="sz"><i>Would man but wake from out his haunted sleep,</i></span></p>
<p class="p1"><span class="sz"><i>Earth might be fair, and all men glad and wise.</i></span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p4"><span class="sz">OLD HUNDRED TWENTY-FOURTH</span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p5"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section6.vue?1b4f1582